export const SELECTORS = {
  FLAVOR_SWITCHER: 'js-flavor-switcher',
  FLAVOR_OPTION: 'js-flavor-switcher-option'
};
